import React, { useRef, useState, useEffect } from 'react';
import {
    Grid,
    Card,
    Box,
    TextField,
    Typography,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "trainerRoutes";
import editRoutes from "trainerEditRoutes";
import CountryList from 'country-list-with-dial-code-and-flag';
import MKBox from "components/MKBox";
import Container from "@mui/material/Container";
import Logo from "assets/images/skill2.png";
import MKButton from "components/MKButton";
import { LocationOn } from '@mui/icons-material';
import MKTypography from "components/MKTypography";
import { useNavigate } from 'react-router-dom';
import MKAlert from "components/MKAlert";
import { getAllISOCodes, getAllInfoByISO } from 'iso-country-currency';
import Modal from "@mui/material/Modal";
import CompanyIcon from "assets/images/companyicon.png";
import Expectation from "assets/images/team_3082743.png";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DatePicker from "react-multi-date-picker";
import Breadcrumbs from "examples/Breadcrumbs";
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import '../../../styles.css';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const LoadingOverlay = ({ loading, children }) => {
    return (
        <>
            {loading && (
                <Backdrop
                    sx={{
                        color: '#fff',
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        filter: 'blur(5px)',
                        pointerEvents: 'none',
                    }}
                    open={loading}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            zIndex: "1",
                            width: "100%",
                            minHeight: "100vh",
                            // display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none',
                            userSelect: 'none',
                        }}
                    >
                        {children}
                    </Box>
                </Backdrop>
            )}
            {loading && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: (theme) => theme.zIndex.drawer + 2,
                    }}
                >
                    <CircularProgress />
                </Box>
            )}
            {!loading && children}
        </>
    );
};

function CustomMultipleInput({ openCalendar, value }) {
    return (
        <div>
            <input type="hidden"
                onFocus={openCalendar}
                value={value}
                readOnly
            />
            <MKButton variant="gradient" color="info" size="small" style={{ marginLeft: "20px" }} onClick={openCalendar} >Select Dates</MKButton>
        </div>
    )
}

const TrainerRecommendedTrainingSeeMore = () => {
    const [recommendedSkillsDetails, setRecommendedSkillsDetails] = useState([]);
    const [skillErrorMessage, setSkillErrorMessage] = useState('');
    const [maxApplyCount, setMaxApplyCount] = useState(false);
    const [selectedTrainingName, setSelectedTrainingName] = useState("");
    const [selectedTrainingID, setSelectedTrainingID] = useState("");
    const [selectedTrainingCompanyId, setSelectedTrainingCompanyId] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [toc, setToc] = useState(null);
    const [tocError, setTocError] = useState(null);
    const [selectionToc, setSelectionToc] = useState("");
    const [trainerProfile, setTrainerProfile] = useState("");
    const [selectedCurrencyCountry, setSelectedCurrencyCountry] = useState('');
    const [commercialsCurrency, setCommercialsCurrency] = useState("");
    const [commercialsLessThan4hrs, setCommercialsLessThan4hrs] = useState("");
    const [commercials4hrs, setCommercials4hrs] = useState("");
    const [commercials8hrs, setCommercials8hrs] = useState("");
    const [lastDeliveredDate, setLastDeliveredDate] = useState("");
    const [lastClient, setLastClient] = useState("");
    const [courseDuration, setCourseDuration] = useState("");
    const [trainingComment, settrainingComment] = useState("");
    const [callAvailableDate, setCallAvailableDate] = useState([]);
    const [trainingAvailableDate, setTrainingAvailableDate] = useState([]);
    const [trainerDetails, setTrainerDetails] = useState([]);
    const [submitApplyCompleted, setSubmitApplyCompleted] = useState(false);
    const [tocS3BucketURL, setTocS3BucketURL] = useState(null);
    const [lab, setLab] = useState("");
    const [labCostPerParticipants, setLabCostPerParticipants] = useState("");
    const [serverCount, setServerCount] = useState("");
    const [typeOfServer, setTypeOfServer] = useState("");
    const [userId, setUserId] = useState("");
    const [currency, setCurrency] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let id = localStorage.getItem("userId");
        setUserId(id);
        fetch(`${process.env.REACT_APP_API_URL}/api/trainer-profile-list/${id}/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.detail) {
                } else {
                    setTrainerDetails(data);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);
    console.log("trainerDetails", trainerDetails);

    useEffect(() => {
        let id = localStorage.getItem("userId");
        console.log(id);
        let display = "nocard";
        fetch(`${process.env.REACT_APP_API_URL}/api/trainer-skills-equvalent/${id}/${display}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (!data.detail) {
                    setSkillErrorMessage(data.message);
                    if (!data.message) {
                        setRecommendedSkillsDetails(data);
                    }
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, [userId]);
    console.log("recommendedSkillsDetails", recommendedSkillsDetails);
    console.log("skillErrorMessage", skillErrorMessage);

    const navigate = useNavigate();

    const onSkillsMoreDetails = (training) => {
        // console.log("training",training.trainingID);
        navigate(`/app/trainingdetails/${training.trainingID}/`);
    };

    const onApplyClick = (training) => {
        setMaxApplyCount(false);
        setLoading(true);
        let id = localStorage.getItem("userId");
        console.log("userId", id);
        let name = training.trainingName;
        let trainingId = training.trainingID.toString();
        setSelectedTrainingName(name);
        setSelectedTrainingID(trainingId);
        let permiumStatus = trainerDetails.premiumStatus;

        fetch(`${process.env.REACT_APP_API_URL}/api/single-training-details/${trainingId}/${id}/${permiumStatus}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (!data.detail && data.message === "User not found") {
                    console.log("123333333333333333333333333333");
                    console.log("details", data.message);
                    let companyID = data.trainingCompanyUserID;
                    setSelectedTrainingCompanyId(companyID);
                    setShowModal(true);
                    setLoading(false);
                    setLoading(false);
                } else if (data.message === "Remainder reached maximum for the day") {
                    console.log("123123123123");
                    setMaxApplyCount(true);
                    setLoading(false);
                } else {
                    console.log("data inside1111111", data);
                    let companyID = data.trainingCompanyUserID;
                    setSelectedTrainingCompanyId(companyID);
                    setShowModal(true);
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    console.log("selectedTrainingName", selectedTrainingName);
    console.log("selectedTrainingID", selectedTrainingID);
    console.log("selectedTrainingCompanyId", selectedTrainingCompanyId);

    const onCloseApplyClick = () => {
        setShowModal(false);
        setCommercialsLessThan4hrs("");
        setCommercials4hrs("");
        setCommercials8hrs("");
        setLab("");
        setServerCount("");
        setTypeOfServer("");
        setLabCostPerParticipants("");
        setTrainingAvailableDate("");
        setCallAvailableDate("");
        setCourseDuration("");
        setLastDeliveredDate("");
        setLastClient("");
        settrainingComment("");
        setTrainerProfile("");
        setSelectedCurrencyCountry("");
        setCurrency("");
        setToc(null);
        setSelectionToc("");
    };

    const handleTrainingProfileChange = (e) => {
        const selectedProfile = e.target.value;
        setTrainerProfile(selectedProfile);

        const experienceArray = trainerDetails.trainingExperience;

        const selectedExperience = experienceArray.find(
            (experience) => experience.profileName === selectedProfile
        );
        if (selectedExperience) {
            setCommercialsLessThan4hrs(selectedExperience.forLessThan4hrs || "");
            setCommercials4hrs(selectedExperience.for4hrs || "");
            setCommercials8hrs(selectedExperience.for8hrs || "");
            setCommercialsCurrency(selectedExperience.commercialsCurrency || "");
            setLastDeliveredDate(selectedExperience.dateOfLastTraining || "");
            setLastClient(selectedExperience.clientDelivered || "");
            setSelectedCurrencyCountry(selectedExperience.selectedCommercialsCurrency || "");
            setCourseDuration(selectedExperience.trainingDuration || "");
        }
    };

    const handleCountryCurrencyChange = (event) => {
        const selectedISO = event.target.value;
        setSelectedCurrencyCountry(selectedISO);

        const currencyInfo = getAllInfoByISO(selectedISO);
        setCurrency(`${currencyInfo.currency} (${currencyInfo.symbol})`);
    };

    console.log("currency", currency);

    const today = new Date().toISOString().split('T')[0];
    const handleLastDeliveredDateChange = (e) => {
        setLastDeliveredDate(e.target.value);
    };
    console.log("lastDeliveredDate", lastDeliveredDate);

    const handleTrainingAvailableChange = (selectedDates) => {
        const formattedDates = selectedDates.map((date) => {
            return date.format('YYYY-MM-DD');
        });

        setTrainingAvailableDate(formattedDates);
    };

    console.log("trainingAvailableDate", trainingAvailableDate);

    const handleCallAvailableDateChange = (selectedDates) => {
        const formattedDates = selectedDates.map((date) => {
            return date.format('YYYY-MM-DD');
        });

        setCallAvailableDate(formattedDates);
    };
    console.log("callAvailableDate", callAvailableDate);

    useEffect(() => {
        let userName = localStorage.getItem("user");
        let id = localStorage.getItem("userId");
        let bucketURL = `trainerhub/${id}_${userName}`;
        setTocS3BucketURL(bucketURL);
    }, [])

    const handleTocChange = (e) => {
        setSelectionToc(e.target.value);
    };
    console.log("selectionToc", selectionToc);

    const tocFileInputRef = useRef(null);

    const handleUploadClick = () => {
        tocFileInputRef.current.click();
    };

    const handleTocUploadChange = (event) => {
        const selectedFile = event.target.files[0];
        const fileExtension = selectedFile.name.split('.').pop();

        if (selectedFile) {
            const allowedFormats = ['pdf', 'docx', 'xlsx', 'xls'];

            if (!allowedFormats.includes(fileExtension.toLowerCase())) {
                setTocError("Please check the file format.");
                return;
            }

            if (selectedFile.size > 5 * 1024 * 1024) {
                setTocError("File size should be maximum 5mb.");
                return;
            }

            setTocError(null);
            const renamedFile = new File([selectedFile], `${selectedTrainingName}_${selectedTrainingID}_toc.${fileExtension}`, { type: selectedFile.type });
            setToc(renamedFile);
        }
    };

    console.log("toc", toc);

    const onSaveApplyClick = async (e) => {
        setLoading(true);
        try {
            const data = {
                appliedTrainerID: userId,
                selectedTrainingID: selectedTrainingID,
                selectedTrainingName: selectedTrainingName,
                trainingCompanyUserID: selectedTrainingCompanyId,
                profileName: trainerProfile,
                applyToc: selectionToc,
                tocURL: tocS3BucketURL,
                currency: commercialsCurrency,
                commercialsForLessThan4hrs: commercialsLessThan4hrs,
                commercialsFor4hrs: commercials4hrs,
                commercialsFor8hrs: commercials8hrs,
                labsByTrainer: lab,
                serverCount: serverCount,
                typeOfServer: typeOfServer,
                labCostPerParticipants: labCostPerParticipants,
                availableDatesForTraining: trainingAvailableDate,
                availableDatesForCall: callAvailableDate,
                courseDurationHRS: courseDuration,
                recentLastDeliveredDate: lastDeliveredDate,
                recentLastDeliveredClient: lastClient,
                comments: trainingComment,
                premiumStatus: trainerDetails.premiumStatus,
                applyTrainingStatus: "1",
            };
            console.log(JSON.stringify(data));
            setLoading(true);
            setShowModal(false);

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/apply-training/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
                body: JSON.stringify(data),
            });

            if (response.ok && toc) {
                const formData = new FormData();
                formData.append('files', toc);

                console.log("formData", formData);
                console.log("s3BucketURL", tocS3BucketURL);

                fetch(`${process.env.REACT_APP_API_URL}/api/upload/${tocS3BucketURL}/applytraining/`, {
                    method: 'POST',
                    body: formData,
                })
                    .then(response => response.json())
                    .then(data => {
                        console.log(data);
                    })
                    .catch(error => {
                        console.error('Error uploading file:', error);
                    });
                console.log("Toc uploaded successfully");
                setShowModal(false);
                setSubmitApplyCompleted(true);
                setLoading(false);
            } else if (response.ok && !toc) {
                setShowModal(false);
                setSubmitApplyCompleted(true);
                setLoading(false);
            } else {
                setShowModal(false);
                setSubmitApplyCompleted(false);
                throw new Error("Profile is not created. Something went wrong");
            }
            // setSubmitCompleted(true);
        } catch (error) {
            console.log("Error:", error.message);
            setSubmitApplyCompleted(false);
        }
    };


    const DialogProfileApplyClose = () => {
        setShowModal(false);
        window.location.href = "/app/trainerdashboard";
    };

    const renderTrainerCards = (trainings) => {
        return trainings.map((training, index) => (
            <Grid item xs={6} key={training.id} >
                <div className="gridItemSeeMore">
                    <div className="gridContent" >
                        <div className="trainingInfo">
                            <Typography variant="subtitle1" className="trainingName"><strong>{training.trainingName}</strong></Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.displaySkills}
                                </span>
                            </Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{training.trainingCompanyName}
                                </span>
                            </Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <LocationOn style={{ marginRight: '5px' }} /> {training.trainingMode}
                                    {training.trainingMode === 'Classroom' ? ` | ${training.trainingLocations}` : ''}
                                </span>
                            </Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    {training.currency}&nbsp;{training.totalTrainingBudget} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.trainingExpectation}
                                </span>
                            </Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <CalendarMonthIcon style={{ marginRight: '5px' }} /> {training.expectedStartDate}
                                </span>
                            </Typography>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                            <MKButton variant="gradient" color="info" size="small" onClick={() => onSkillsMoreDetails(training)} style={{ padding: '5px 10px' }}>Details</MKButton>
                            {/* <MKButton  size="small" onClick={() => onSkillsMoreDetails(training)} style={{ padding: '5px 10px' }}>Details</MKButton> */}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                            <MKButton variant="gradient" color="info" size="small" onClick={() => onApplyClick(training)} style={{ padding: '5px 10px' }}>Apply</MKButton>
                            {/* <MKButton size="small" onClick={() => onApplyClick(training)} style={{ padding: '5px 10px' }}>Apply</MKButton> */}
                        </div>
                    </div>
                </div>
            </Grid>
        ));
    };


    return (
        <>
            <LoadingOverlay loading={loading}>
                <IdleTimeOutHandler />
                <DefaultNavbar
                    routes={editRoutes}
                    sticky
                />
                <Card
                    sx={{
                        minHeight: '101vh',
                        height: 'auto',
                        p: 2,
                        mx: { xs: 2, lg: 3 },
                        mt: -8,
                        mb: 4,
                        // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
                        backdropFilter: "saturate(200%) blur(30px)",
                        boxShadow: ({ boxShadows: { xxl } }) => xxl,
                    }}
                >

                    <Modal open={showModal} onClose={() => setShowModal(false)} sx={{ display: "grid", placeItems: "center" }}>
                        <MKBox
                            position="relative"
                            width="850px"
                            display="flex"
                            flexDirection="column"
                            borderRadius="xl"
                            bgColor="white"
                            shadow="xl"
                        >
                            <div>
                                <h2 style={{ whiteSpace: 'nowrap', marginLeft: '10px' }}>
                                    {selectedTrainingName ? selectedTrainingName : 'Default Training Name'}
                                </h2>
                                <Grid container spacing={2}>
                                    <Grid item xs={4} style={{ marginTop: "20px" }}>
                                        <div>
                                            <FormControl variant="outlined" style={{ width: '250px' }}>
                                                <InputLabel style={{ marginLeft: "10px" }} id="select-trainingProfile-label">Select Your Training Profile *</InputLabel>
                                                <Select
                                                    labelId="select-trainingProfile-label"
                                                    label="Select Your Training Profile *"
                                                    fullWidth
                                                    onChange={handleTrainingProfileChange}
                                                    value={trainerProfile}
                                                    style={{ minHeight: '44px', width: '250px', marginLeft: "10px" }}
                                                >

                                                    {trainerDetails.trainingExperience && trainerDetails.trainingExperience.map((experience, index) => (
                                                        <MenuItem key={index} value={experience.profileName}>
                                                            {experience.profileName}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4} style={{ marginTop: "20px" }}>
                                        <div>
                                            <FormControl variant="outlined" style={{ width: '250px' }}>
                                                <InputLabel id="country-currency" shrink={!!selectedCurrencyCountry}>Country *</InputLabel>
                                                <Select
                                                    labelId="country-currency"
                                                    label="Country *"
                                                    fullWidth
                                                    onChange={handleCountryCurrencyChange}
                                                    value={selectedCurrencyCountry}
                                                    style={{ minHeight: '44px' }}
                                                >
                                                    {getAllISOCodes().map((country) => (
                                                        <MenuItem key={country.iso} value={country.iso}>
                                                            {country.countryName}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4} style={{ marginTop: "20px" }}>
                                        <div>
                                            <Typography variant="subtitle2" style={{ marginTop: "10px" }}>
                                                <span>Currency: {commercialsCurrency}</span>
                                            </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "20px", marginRight: "22px" }}>
                                        <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Commercials per hour</span> }]} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4} style={{ marginTop: "20px" }}>
                                        <div>
                                            <TextField
                                                label="For less than 4 hours *"
                                                variant="outlined"
                                                style={{ width: '250px', marginLeft: "10px" }}
                                                value={commercialsLessThan4hrs}
                                                onChange={(e) => setCommercialsLessThan4hrs(e.target.value)}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={4} style={{ marginTop: "20px" }}>
                                        <div>
                                            <TextField
                                                label="For 4 hours *"
                                                variant="outlined"
                                                style={{ width: '250px' }}
                                                value={commercials4hrs}
                                                onChange={(e) => setCommercials4hrs(e.target.value)}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={4} style={{ marginTop: "20px" }}>
                                        <div>
                                            <TextField
                                                label="For 8 hours *"
                                                variant="outlined"
                                                style={{ width: '250px' }}
                                                value={commercials8hrs}
                                                onChange={(e) => setCommercials8hrs(e.target.value)}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4} style={{ marginTop: "30px" }}>
                                        <div>
                                            <InputLabel style={{ marginLeft: '10px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>
                                                Last Delivered Date
                                            </InputLabel>
                                            <TextField
                                                type="month"
                                                id="lastDelivered_date"
                                                value={lastDeliveredDate || ""}
                                                onChange={handleLastDeliveredDateChange}
                                                style={{ width: "250px", marginLeft: "10px" }}
                                                InputProps={{
                                                    inputProps: {
                                                        max: new Date().toISOString().split('T')[0].substring(0, 7),
                                                    },
                                                }}
                                                fullwidth
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={4} style={{ marginTop: "30px" }}>
                                        <div>
                                            <TextField
                                                label="Last Delivered Client"
                                                variant="outlined"
                                                style={{ width: '250px' }}
                                                value={lastClient}
                                                onChange={(e) => setLastClient(e.target.value)}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={4} style={{ marginTop: "30px" }}>
                                        <div>
                                            <TextField
                                                label="Training Duration (in hours) *"
                                                variant="outlined"
                                                style={{ width: '250px' }}
                                                value={courseDuration}
                                                onChange={(e) => setCourseDuration(e.target.value)}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "20px", marginRight: "22px" }}>
                                        <Breadcrumbs
                                            routes={[{ label: "Available Dates For Training" }]}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "10px" }}>
                                        <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.9rem' }}>
                                            From When
                                            <DatePicker
                                                multiple
                                                id="selectedDates"
                                                style={{ marginLeft: '20px' }}
                                                render={<CustomMultipleInput />}
                                                onChange={handleTrainingAvailableChange}
                                                value={trainingAvailableDate}
                                                minDate={new Date()}
                                            // maxDate={fbmaxDate}
                                            />
                                        </Typography>
                                        {trainingAvailableDate.length > 0 && (
                                            <Typography style={{ marginTop: '5px' }} variant="body2" fontWeight="regular">
                                                <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.9rem' }} component="span">
                                                    Selected Dates For Training:
                                                </Typography>{' '}
                                                {trainingAvailableDate.join(', ')}
                                            </Typography>
                                        )}
                                    </Grid>
                                </Grid>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "20px", marginRight: "22px" }}>
                                        <Breadcrumbs
                                            routes={[{ label: "Available Dates For Calls" }]}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "10px" }}>
                                        <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.9rem' }}>
                                            From When
                                            <DatePicker
                                                multiple
                                                id="selectedDates"
                                                style={{ marginLeft: '20px' }}
                                                render={<CustomMultipleInput />}
                                                onChange={handleCallAvailableDateChange}
                                                value={callAvailableDate}
                                                minDate={new Date()}
                                            // maxDate={fbmaxDate}
                                            />
                                        </Typography>
                                        {callAvailableDate.length > 0 && (
                                            <Typography style={{ marginTop: '5px' }} variant="body2" fontWeight="regular">
                                                <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.9rem' }} component="span">
                                                    Selected Dates For Call:
                                                </Typography>{' '}
                                                {callAvailableDate.join(', ')}
                                            </Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                        <div>
                                            <TextField
                                                label="Note"
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                style={{ width: '530px', marginLeft: "10px" }}
                                                value={trainingComment}
                                                onChange={(e) => {
                                                    settrainingComment(e.target.value);
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={4} style={{ marginTop: "10px", marginLeft: "280px" }}>
                                        <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', fontSize: '0.9rem' }}>
                                            Is TOC available? *
                                        </Typography>

                                        <FormControl component="fieldset" style={{ marginLeft: '0px' }}>
                                            <RadioGroup row aria-label="toc" name="selectionToc" value={selectionToc} onChange={handleTocChange}>
                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                    <FormControlLabel value="yes" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="Yes" />
                                                    <FormControlLabel value="no" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="No" />
                                                </Box>
                                            </RadioGroup>
                                        </FormControl>
                                        {/* </Grid> */}
                                        {selectionToc === 'yes' && (
                                            <>
                                                <MKTypography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', fontSize: '0.9rem' }}>
                                                    TOC format in .pdf, .docx, .xlsx, .xls
                                                </MKTypography>
                                                <input
                                                    type="file"
                                                    id="toc-upload"
                                                    accept="pdf/*"
                                                    style={{ display: 'none' }}
                                                    ref={tocFileInputRef}
                                                    onChange={handleTocUploadChange}
                                                />
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <label htmlFor="toc-upload">
                                                        <MKButton onClick={handleUploadClick} variant="gradient" color="info" size="small" style={{ whiteSpace: 'nowrap' }}>
                                                            Upload TOC
                                                        </MKButton>
                                                    </label>
                                                    {toc && (
                                                        <div style={{ fontSize: '14px', marginLeft: "10px" }}>
                                                            <span> {toc.name}</span>
                                                        </div>
                                                    )}
                                                </div>
                                                {tocError && (
                                                    <MKTypography style={{ color: 'red', fontSize: 'small', marginLeft: '20px', marginTop: '5px' }}>
                                                        {tocError}
                                                    </MKTypography>
                                                )}
                                            </>
                                        )}
                                    </Grid>
                                </Grid>
                                <div style={{ display: 'flex', marginBottom: "20px", marginLeft: "10px" }}>
                                    <MKButton variant="gradient" color="info" size="small" onClick={onCloseApplyClick}>
                                        Cancel
                                    </MKButton>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-50px", marginRight: "10px", marginBottom: "10px" }}>
                                    <MKButton variant="gradient" color="info" size="small" disabled={!trainerProfile || !selectedCurrencyCountry || !commercialsLessThan4hrs || !commercials4hrs || !commercials8hrs || !courseDuration || !selectionToc} onClick={onSaveApplyClick}>
                                        Apply
                                    </MKButton>
                                </div>
                            </div>
                        </MKBox>
                    </Modal>
                    <Dialog
                        open={submitApplyCompleted}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            Fantastic news!
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Your application for the training has been successfully submitted. Get ready for an enriching experience ahead!
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                            <MKButton onClick={() => { setSubmitApplyCompleted(false); DialogProfileApplyClose(); }} variant="contained" color="info" size="small" autoFocus>
                                OK
                            </MKButton>
                        </DialogActions>
                    </Dialog>
                    <Container>
                        <Grid container>
                            <Grid item xs={12} style={{ marginTop: "150px" }}>
                                <div>
                                    {maxApplyCount ? (
                                        <MKAlert color="error" dismissible >
                                            You've reached the daily apply limit !
                                        </MKAlert>
                                    ) : (
                                        ""
                                    )}
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                                        <Grid item xs={12} style={{ display: 'flex' }}>
                                            <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                                                <span style={{ color: 'black' }}>Recommended</span>{' '}
                                                <span style={{ color: '#2e1114' }}>Trainings</span>
                                            </MKTypography>
                                        </Grid>
                                    </Grid>

                                    {recommendedSkillsDetails.length === 0 ? (
                                        <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>Improve your profile by adding or updating your skills to unlock relevant training opportunities.</span>
                                    ) : (
                                        ""
                                    )}

                                    {recommendedSkillsDetails.length === 0 ? (
                                        ""
                                    ) : (
                                        <Grid container spacing={2}>
                                            {renderTrainerCards(recommendedSkillsDetails)}
                                        </Grid>
                                    )}

                                </div>
                            </Grid>
                        </Grid>
                    </Container>
                </Card>
            </LoadingOverlay>
        </>
    );
};

export default TrainerRecommendedTrainingSeeMore;